module.exports = __webpack_public_path__ + "16573c28841b43e641e17cee6e425300.mp3";